import { TabularCopySink } from './tabular.copysink';
import { Metamodel } from 'app/model/base/model';
import { IAttribute, IModel } from 'app/model/base/annotation';
import { AmazonRedshiftTableDataset } from 'app/model/dataset/amazon-redshift.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';

@Metamodel.model({
    name: adfModelTypeMap.amazonRedshift.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: [Metamodel.modelFor(AmazonRedshiftTableDataset)] }
})
export class AmazonRedshiftSink extends TabularCopySink {
    public static readonly MODEL: IModel;
    public static readonly WRITE_BEHAVIOR: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BEHAVIOR',
        display: stringResources.ModelName_WriteBehavior
    })
    public writeBehavior?: string = writeBehaviorOptionValues.insert;
}